import axios from "axios";
import DOMPurify from "dompurify";
import { useEffect, useRef, useState } from "react";

function ChatWindow({ selectedChat, baseUrl, onChatCreated,onBack }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const [newMessage, setNewMessage] = useState("");
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const userType = user?.user_type;
  const scrollRef = useRef(null);
  const fileInputRef = useRef(null);
  const [showNewMessageDivider, setShowNewMessageDivider] = useState(false);

  // Auto-scroll
  useEffect(() => {
    if (scrollRef.current)
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, loading]);

  const getFileUrl = (filePath) => {
    if (!filePath) return "";
    if (/^https?:\/\//.test(filePath)) return filePath;
    return `${baseUrl}${filePath}`;
  };

  const otherAvatar = selectedChat?.profile_pic
    ? getFileUrl(selectedChat.profile_pic)
    : selectedChat?.profile_image
    ? getFileUrl(selectedChat.profile_image)
    : "images/user_dh.png";

  // Fetch messages for this partner user_id
  useEffect(() => {
    if (!selectedChat) return;
    const receiverId = selectedChat.user_id;
    if (!receiverId) return;

    const fetchMessages = async () => {
      try {
        setLoading(true);
        const endpoint =
          userType === 1
            ? `${process.env.REACT_APP_API_BASE}/chat/host/${receiverId}`
            : `${process.env.REACT_APP_API_BASE}/chat/user/${receiverId}`;

        const res = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const fetched = Array.isArray(res.data?.data) ? res.data.data : [];
        setMessages(fetched); // don't mutate is_read yet
      } catch (err) {
        console.error("Error fetching messages", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [selectedChat, userType, token]);

  // Handle "New Message Divider"
  useEffect(() => {
    if (!messages || messages.length === 0) return;
    const hasUnread = messages.some((m) => m.is_read === 0);
    if (hasUnread) {
      setShowNewMessageDivider(true);
      const timer = setTimeout(() => setShowNewMessageDivider(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [messages]);

  // Mark unread as read (after short delay)
  useEffect(() => {
    if (!messages || messages.length === 0) return;

    const unreadIds = messages.filter((m) => m.is_read === 0).map((m) => m.id);
    if (unreadIds.length === 0) return;

    const timer = setTimeout(async () => {
      try {
        await axios.post(
          `${process.env.REACT_APP_API_BASE}/chat/mark-read`,
          { message_ids: unreadIds },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setMessages((prev) =>
          prev.map((m) =>
            unreadIds.includes(m.id) ? { ...m, is_read: 1 } : m
          )
        );
      } catch (err) {
        console.error("Error marking messages as read", err);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [messages, token]);

  // File handling
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setAttachedFiles((prev) => [...prev, ...files]);
    e.target.value = null;
  };

  const removeAttachedFile = (index) => {
    setAttachedFiles((prev) => prev.filter((_, i) => i !== index));
    if (fileInputRef.current) fileInputRef.current.value = null;
  };

  // Send message (first send implicitly creates thread on server)
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!selectedChat || (!newMessage.trim() && attachedFiles.length === 0))
      return;

    try {
      const receiverType = userType === 1 ? "host" : "user";
      const receiverId = selectedChat.user_id;
      if (!receiverId) return;

      let didCreateThreadCallback = false;

      const filesToSend = attachedFiles.length ? attachedFiles : [null];
      for (let file of filesToSend) {
        const formData = new FormData();
        formData.append("receiver_type", receiverType);
        formData.append("receiver_id", receiverId);
        formData.append("message", newMessage.trim() || "");
        if (file) formData.append("file", file);

        const res = await axios.post(
          `${process.env.REACT_APP_API_BASE}/chat/send`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const created = res?.data?.data;

        const newMsg = {
          id: created?.id || Date.now(),
          sender_type: userType === 1 ? "user" : "host",
          message: created?.message || newMessage.trim() || "",
          files: created?.file_path
            ? [
                {
                  file_path: created.file_path,
                  file_type: created?.file_type || file?.type || "none",
                },
              ]
            : [],
          created_at: created?.created_at || new Date().toISOString(),
          is_read: 1,
        };

        setMessages((prev) => {
          const updated = [...prev, newMsg];
          localStorage.setItem(
            `chat_${selectedChat.user_id}`,
            JSON.stringify(updated)
          );
          return updated;
        });

        // Notify parent to move chat to top instantly
        if (!didCreateThreadCallback) {
          didCreateThreadCallback = true;
          onChatCreated?.({
            user_id: receiverId,
            // last_message: newMessage.trim() || "📎 Attachment",
            // last_message_time: new Date().toISOString(),
          });
        }
      }

      setNewMessage("");
      setAttachedFiles([]);
    } catch (err) {
      console.error("Error sending message", err);
    }
  };

  if (!selectedChat) {
    return (
      <div className="msg_rights">
        <p className="nodataersh">Select a chat to start messaging</p>
      </div>
    );
  }

  return (
    <div className="msg_rights">

      

      {/* Header */}
      <div className="top_managses">
        <div className="un_litingss">
		  <button className="mobile-back-btn mb_view_show" onClick={onBack}> <i className="fa fa-angle-left"></i> </button>
          <div className="usr_mgs">
            <img
              src={otherAvatar}
              alt={`${selectedChat.first_name || ""} ${
                selectedChat.last_name || ""
              }`}
              onError={(e) => (e.currentTarget.src = "images/user_dh.png")}
            />
          </div>
          <div className="tx_contents">
            <h4>
              {selectedChat.first_name} {selectedChat.last_name}
            </h4>
            <p>
              <span className="diss_tx">
                {selectedChat.last_message || ""}
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Chat Body */}
      <div className="chats_box" ref={scrollRef}>
        <div className="cnt_btnss">
          <span className="al_btnss">Today</span>
        </div>

        {loading && (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <span>Loading messages...</span>
          </div>
        )}

        <div className="chats_mainss">
          {messages.map((msg, index) => {
            const isMine =
              userType === 1
                ? msg.sender_type === "user"
                : msg.sender_type === "host";
            const time = new Date(msg.created_at).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            });
            const unreadClass = msg.is_read === 0 ? "unread-msg" : "";

            return (
              <div key={msg.id}>
                {showNewMessageDivider &&
                  index === messages.findIndex((m) => m.is_read === 0) && (
                    <div className="new-message-divider">
                      <span>New Message</span>
                    </div>
                  )}

                {isMine ? (
                  <div className="lft_chats rightarea">
                    <div className="rightss">
                      <div className="txtx_area">
                        <p>
                          <span className="tmss">{time}</span> You
                        </p>
                        {/* <div className="mssg_txt">{msg.message}</div> */}
                        <div className="mssg_txt"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(msg.message, {
                              ADD_ATTR: ["target", "rel"], // allow safe link attributes
                              ADD_TAGS: ["a"],
                              FORBID_ATTR: ["onclick", "onerror", "style"], // block dangerous stuff
                              RETURN_TRUSTED_TYPE: false,
                            }).replace(
                              /<a /g,
                              "<a target='_blank' rel='noopener noreferrer' "
                            ),
                          }}
                        >
                   </div>
                      </div>
                    </div>
                    <div className="usr_mgss">
                      <img
                        src={
                          user?.profile_image
                            ? getFileUrl(
                                user.base_url
                                  ? `${user.base_url}/${user.profile_image.replace(
                                      /^\//,
                                      ""
                                    )}`
                                  : user.profile_image
                              )
                            : "/images/user_dh.png"
                        }
                        alt="you"
                      />
                    </div>
                  </div>
                ) : (
                  <div className={`lft_chats ${unreadClass}`}>
                    <div className="usr_mgss">
                      <img
                        src={otherAvatar}
                        alt="other"
                        onError={(e) =>
                          (e.currentTarget.src = "images/user_dh.png")
                        }
                      />
                    </div>
                    <div className="txtx_area">
                      <p>
                        {selectedChat.first_name}{" "}
                        <span className="tmss">{time}</span>
                      </p>
                      {/* <div className="mssg_txt">{msg.message}</div> */}
                      <div className="mssg_txt"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(msg.message, {
                              ADD_ATTR: ["target", "rel"], // allow safe link attributes
                              ADD_TAGS: ["a"],
                              FORBID_ATTR: ["onclick", "onerror", "style"], // block dangerous stuff
                              RETURN_TRUSTED_TYPE: false,
                            }).replace(
                              /<a /g,
                              "<a target='_blank' rel='noopener noreferrer' "
                            ),
                          }}
                        >
                   </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Message Input */}
      <div className="cht_messages_bx">
        <form onSubmit={handleSendMessage}>
          <div className="frm_box">
            <div className="inp">
              <input
                type="text"
                placeholder="Type a message"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
              />
            </div>

            <div className="boths_ic_sub">
              <div className="submmits">
                <button type="submit">Send</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ChatWindow;
